// Package Imports
import { useLayoutEffect, useState } from "react";

// Internal Imports
import {
  EValidSSOKey,
  EQueryKeys,
  IUseSSODataOutput
} from "../../../types";

export const useSSOData = () => {
  const [isData, setData] = useState<IUseSSODataOutput | null>(null);
  const [isError, setError] = useState<Error | null>(null);
  const [isLoading, setLoading] = useState<boolean>(false);

  useLayoutEffect(() => {
    const processValidSSO = async () => {
      try {
        // STATE - Start Loading
        setLoading(true);

        // Iterate over EQueryKeys and retrieve values from sessionStorage
        const ssoKeys = [...Object.values(EQueryKeys), ...Object.values(EValidSSOKey)];

        const ssoData: IUseSSODataOutput = ssoKeys.reduce((result, key) => {
          const value = sessionStorage.getItem(key);

          if (key === EValidSSOKey.VALID_SSO) {
            // EValidSSOKey.VALID_SSO - Set Boolean Value
            if (!value) {
              result[key] = false;
              return result;
            }

            // SET KEY/VALUE - Known/Expected value type is boolean
            result[key] = JSON.parse(value);

            return result;
          }

          result[key] = value;

          return result;
        }, {} as any);

        setData(ssoData);

        // STATE - End Loading
        setLoading(false);
      } catch (err) {
        // STATE - Set Error
        setError(err);

        // STATE - End Loading
        setLoading(false);
      }
    }

    processValidSSO();
  }, []);

  return {
    validSSOData: isData,
    validSSOError: isError,
    validSSOLoading: isLoading
  }
}
